/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { Fragment, useContext } from "react"
import LocalOfferRoundedIcon from "@material-ui/icons/LocalOfferRounded"
import { Chip } from "@material-ui/core"
import { CartOrderDetails } from "./cartTypes"
import AuthContext from "../../context/AuthContext"
import { Theme } from "../types"

type Props = {
    productOrder: CartOrderDetails
}

function CartListDiscountSign({ productOrder }: Props) {
    const auth = useContext(AuthContext)

    const hasDiscount =
        auth?.role === "admin" &&
        productOrder.numberInOrder &&
        productOrder.productInfo?.basePrice &&
        productOrder.numberInOrder *
            Number(productOrder.productInfo?.basePrice) !==
            productOrder.calculatedPrice
    return (
        <Fragment>
            {hasDiscount && auth?.role === "admin" && (
                <Chip
                    label="Egyedi"
                    variant="outlined"
                    color="secondary"
                    icon={<LocalOfferRoundedIcon />}
                    data-testid="chip_discount"
                    css={styles.root}
                />
            )}
        </Fragment>
    )
}

export default CartListDiscountSign

const styles = {
    root: (theme: Theme) => css`
        color: ${theme.colors.secondary[600]};
        border-color: ${theme.colors.secondary[600]};
        font-weight: 600;
    `,
}
